import Navigation from "@/pages/home/components/Navigation";

/* The top of a page that is not the home: the skip link, the header of the
   site and the room its fixed bar takes. The case studies get it from their
   wrappers (CaseVersions, ProtectedPageGate), so the header stays on screen
   on every page and people can always go back to the home.
   It comes first in the page, before the Short / Full switch, so the skip
   link is the first stop of the keyboard. */
export default function SiteTop() {
  return (
    <>
      <a
        href="#main-content"
        className="site-skip sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[100] focus:px-4 focus:py-3 focus:bg-white focus:text-gray-950 focus:rounded-md focus:text-sm focus:font-medium focus:shadow-lg"
      >
        Skip to content
      </a>
      <Navigation />
      <div className="site-nav-space" aria-hidden="true" />
    </>
  );
}
